import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const myV2RedirectURL = process.env.REACT_APP_MY_V2_REDIRECT_URL;

const setV2AsDefault = () => {
  localStorage.setItem("isV2Default", "true");
  redirectToV2();
};

const removeV2AsDefault = () => {
  localStorage.removeItem("isV2Default");
};

const isV2Default = () => !!localStorage.getItem("isV2Default");

const redirectToV2 = () => window.location.replace(myV2RedirectURL);

const usePortalRedirection = (validateRedirection = false) => {
  const location = useLocation();
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (validateRedirection) {
      const path = location.pathname;
      const isFromReturnRoute = path === "/return-to-new-version";

      if (isFromReturnRoute || !myV2RedirectURL) {
        removeV2AsDefault();
        setInitialized(true);
      } else if (isV2Default()) {
        redirectToV2();
      } else {
        setInitialized(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { initialized, setV2AsDefault };
};

export default usePortalRedirection;
